import { ActionIcon, Group, HoverCard, List, ListItem, Text } from "@mantine/core";
import React, { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import PopOver from "../../../../components/View/PopOver";
import { IconPlus } from "@tabler/icons-react";
import CommunityChanger from "../../admin/right/CommunityManager/CommunityChanger";


const Adder = ({ profile, setProfile, type }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <ActionIcon
          variant="light"
          color="primary"
          ref={ref}
          onClick={handleOpen}
          loading={loading}
          // disabled={changingProfile}
          ml={"auto"}
        >
          <IconPlus size={18} />
        </ActionIcon>
      )}
      popoverChildren={(closePopover) => (
        <CommunityChanger
          setLoading={setLoading}
          handleClose={closePopover}
          profile={profile}
          setProfile={setProfile}
          type={type}
        />
      )}
    />
  );
};

const CommunityCell = ({ value = [], tableLoading, row, apiRef, type }) => {
  return (
    <Group>
      {
        value?.length < 2 ?
          <Text truncate>{value?.[0]?.name}</Text>
          :
          <HoverCard position="top">
            <HoverCard.Target>
              <Text truncate>
                {value[0].name} +{value.length - 1}
              </Text>
            </HoverCard.Target>

            <HoverCard.Dropdown p={"sm"}>
              <List>
                {value
                  .filter((_, i) => i > 0)
                  .map((item) => (
                    <ListItem key={item.id}> {item.name} </ListItem>
                  ))}
              </List>
            </HoverCard.Dropdown>
          </HoverCard>
      }
      <Adder profile={row} setProfile={(data) => apiRef.current.updateRows([data])} type={type} />
    </Group>
  );
};

export default CommunityCell;
